import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {LightTableColumn} from '../../common/light-table/light-table.component';
import {DataService} from '../../../Services/data.service';
import {AppConfigService} from '../../../Services/app-config.service';
import {StorageService} from '../../../Services/storage.service';
import {Title} from '@angular/platform-browser';
import {BsToastService} from '../../../Services/bs-toast-service';

@Component({
  selector: 'app-crm-customer-list',
  templateUrl: './crm-customer-list.component.html',
  styleUrls: ['./crm-customer-list.component.css'],
  standalone: false
})
export class CrmCustomerListComponent implements OnInit {

  permissions: any = {};
  isLoading = true;

  entities: any[] = [];
  totalRecords = 0;
  page = 0;
  pageSize = 25;

  // Filters
  filterType = '';
  filterSearch = '';

  tableColumns: LightTableColumn[] = [
    {key: 'entityName', label: 'Name', sortable: true},
    {key: 'type', label: 'Type', sortable: false},
    {key: 'salesperson_name', label: 'Salesperson'},
    {key: 'last_interaction_date', label: 'Last Interaction', sortable: false},
    {key: 'days_since_contact', label: 'Days Since Contact', sortable: false},
    {key: 'current_balance', label: 'Balance', align: 'right'},
    {key: 'actions', label: 'Actions', sortable: false},
  ];

  // Log Interaction modal
  logInteractionForId: string | null = null;
  activeCompanyId: string | null = null;

  get filteredEntities(): any[] {
    if (!this.filterSearch) {
      return this.entities;
    }
    const q = this.filterSearch.toLowerCase();
    return this.entities.filter(e =>
      (e.entityName ?? '').toLowerCase().includes(q) ||
      (e.salespersonName ?? '').toLowerCase().includes(q)
    );
  }

  constructor(
    private dataService: DataService,
    private localStorage: StorageService,
    private appConfig: AppConfigService,
    private titleService: Title,
    private toast: BsToastService,
    private router: Router
  ) {
    this.permissions = JSON.parse(this.localStorage.StorageGet('Permissions', ''));
  }

  ngOnInit(): void {
    this.titleService.setTitle('CRM Customers');
    this.loadEntities();
  }

  loadEntities(): void {
    this.isLoading = true;
    const companyId = this.localStorage.StorageGet('default_company_id', '');
    let params = '?page=' + this.page + '&pageSize=' + this.pageSize;
    if (companyId) {
      params += '&company_id=' + encodeURIComponent(companyId);
    }
    if (this.filterType) {
      params += '&type=' + encodeURIComponent(this.filterType);
    }

    const url = 'crm/entities' + params;
    this.dataService.getData(url).subscribe({
      next: (result: any) => {
        console.log('crm-customer-list result:', result);
        this.entities = result?.items ?? result ?? [];
        this.totalRecords = result?.total ?? this.entities.length;
        this.loadArBalances(companyId);
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  loadArBalances(companyId: string): void {
    const balParams = 'subLedger=ar' + (companyId ? '&company_id=' + encodeURIComponent(companyId) : '');
    this.dataService.getData('aging', '?' + balParams).subscribe({
      next: (result: any) => {
        // aging returns array of entity objects: { id, invoices: [{ owing, ... }] }
        const rows: any[] = Array.isArray(result) ? result : (result?.items ?? []);
        const balMap: Record<string, number> = {};
        for (const row of rows) {
          const eid = row.id ?? row.entity_id ?? row.entityId;
          if (eid) {
            let total = 0;
            if (Array.isArray(row.invoices)) {
              for (const inv of row.invoices) {
                total += inv.owing ?? 0;
              }
            } else {
              total = row.owing ?? row.balance ?? 0;
            }
            balMap[eid] = (balMap[eid] ?? 0) + total;
          }
        }
        for (const e of this.entities) {
          e.openBalance = balMap[e.entityId] ?? 0;
        }
      }
    });
  }

  onFilterChange(): void {
    this.page = 0;
    this.loadEntities();
  }

  onPageChange(newPage: number): void {
    this.page = newPage;
    this.loadEntities();
  }

  onRowAction(event: { action: string; row: any }): void {
    if (event.action === 'log') {
      this.openLogInteraction(event.row.entityId ?? event.row.entity_id);
    } else if (event.action === 'view') {
      this.router.navigate(['/crm/customers', event.row.entityId ?? event.row.entity_id]);
    }
  }

  openLogInteraction(entityId: string): void {
    const entity = this.entities.find(e => (e.entityId ?? e.entity_id) === entityId);
    this.activeCompanyId = entity?.companyId ?? entity?.company_id ?? this.localStorage.StorageGet('default_company_id', '');
    this.logInteractionForId = entityId;
  }

  cancelLogInteraction(): void {
    this.logInteractionForId = null;
    this.activeCompanyId = null;
  }

  onInteractionSaved(): void {
    this.logInteractionForId = null;
    this.activeCompanyId = null;
    this.loadEntities();
  }
}
